module.exports = __webpack_public_path__ + "static/media/pointcould_logo.170b83fc.png";